import Logo from "./icon/logo.svg";
import WhiteLogo from "./icon/logowhite.svg";
import UserImg from "./user.jpg";
import Footicon1 from "./icon/footicon1.svg";
import Footicon2 from "./icon/footicon2.svg";
import Footicon3 from "./icon/footicon3.svg";
import Filter from "./icon/filter.svg";
import List1 from "./list1.jpg";
import List2 from "./list2.jpg";
import List3 from "./list3.jpg";
import List4 from "./list4.jpg";
import List5 from "./list5.jpg";
import Slider_IMG from "./slider.jpg";
import Map_Img from "./map.jpg";
import Bath_Img from "./icon/bath.svg";
import M2_Img from "./icon/m2.svg";
import Guests_Img from "./icon/guests.svg";
import Bed_Img from "./icon/bed.svg";
import ReviewImg1 from "./review.jpg";
import Calender_Img from "./cal.jpg";
import Map_Img1 from "./map1.jpg";
import Login_Bg from "./loginbg.jpg";
import UserImg11 from "./uuser1.jpg";
import UserImg1 from "./user1.jpg";
import UserImg2 from "./user2.jpg";
import UserImg3 from "./user3.jpg";
import UserImg4 from "./user4.jpg";
import UserImg5 from "./user5.jpg";
import UserImg6 from "./user6.jpg";
import UserImg7 from "./user7.jpg";
import ReferBg from "./referbg.jpg";
import Map_Img2 from "./mopmobile.jpg";
import UserDisImage from "./displayImg.png";
import MapPin from "./MapPin.png";
import PlaceHolderUserImage from "./placeholderImage.png";
export const IMAGES = {
  Map_Img2,
  ReferBg,
  UserImg11,
  UserImg1,
  UserImg2,
  UserImg3,
  UserImg4,
  UserImg5,
  UserImg6,
  UserImg7,
  Login_Bg,
  Map_Img1,
  Calender_Img,
  ReviewImg1,
  List5,
  List4,
  Slider_IMG,
  Bed_Img,
  Guests_Img,
  Bath_Img,
  M2_Img,
  Map_Img,
  List1,
  List2,
  List3,
  Logo,
  WhiteLogo,
  UserImg,
  Footicon1,
  Footicon2,
  Footicon3,
  Filter,
  UserDisImage,
  MapPin,PlaceHolderUserImage
};

const appTheme = { IMAGES };
export default appTheme;
